import axios from "axios";

// const url = process.env.REACT_APP_API_URL;
const url = process.env.REACT_APP_API_URL;
const urlInsurance = process.env.REACT_APP_INSURANCE_API_URL;
// const urlInsurance = "https://dev.api.sugurtapolis.uz/api/v1";

export const api = axios.create({
  baseURL: url,
});
export const apiInsurance = axios.create({
  baseURL: urlInsurance,
});

api.defaults.headers.common["Accept"] = "application/json";
apiInsurance.defaults.headers.common["Accept"] = "application/json";
// api.defaults.headers.common["Content-Type"] = "application/json; charset=utf-8";

export const formData = (obj, form, namespace) => {
  const fd = form || new FormData();
  let formKey;

  for (const property in obj) {
    if (obj.hasOwnProperty(property)) {
      if (namespace) {
        formKey = namespace + "[" + property + "]";
      } else {
        formKey = property;
      }

      if (
        typeof obj[property] === "object" &&
        !(obj[property] instanceof File)
      ) {
        formData(obj[property], fd, property);
      } else {
        fd.append(formKey, obj[property]);
      }
    }
  }
  return fd;
};
